import { createSelector } from "reselect";
import _ from "underscore";

import getUniformatTrades from "./get_uniformat_trades";

const getSelectedUniformatTradeCodes = createSelector([
  getUniformatTrades
], (uniformatTrades) => new Set(_.chain(uniformatTrades)
  .pick((selected) => selected === 1 || selected === -1)
  .keys()
  .value()) as Set<string>);

export default getSelectedUniformatTradeCodes;
